import { StyledContainer } from "./StyledComponents";
import { ServerTimeHelper } from "@kaltura/mediaspace-shared-utils";
import Title from "./title/Title";
import Schedule from "./schedule/Schedule";
import Actions from "./actions/Actions";
import { LobbyProps } from "../Lobby";

export interface DetailsProps extends Omit<LobbyProps, "videoUrl" | "thumbnailUrl" | "schedulingData"> {
    startTime?: number;
    endTime?: number;
}

/**
 * Lobby Details - title, scheduling, actions.
 */
const Details = (props: DetailsProps) => {
    const { startTime, endTime, statusLabel, alwaysShowStatusLabel, title, actions } = props;

    const staticClassBase = "kms-ds-media-page-lobby-details";

    const isScheduled = !!startTime && !!endTime;
    const showCounter = isScheduled && ServerTimeHelper.getUpdatedTime() < startTime;

    return (
        <StyledContainer className={staticClassBase}>
            {(title || alwaysShowStatusLabel) && (
                <Title title={title} showCounter={showCounter} startTime={startTime} statusLabel={statusLabel} />
            )}

            {isScheduled && <Schedule startTime={startTime ?? 0} endTime={endTime ?? 0} />}

            {actions && actions.length > 0 && <Actions actions={actions} />}
        </StyledContainer>
    );
};

export default Details;
